/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { snackWrapper } from "helpers";
import styles from "./CustomLink.module.sass";

interface ICustomLinkForAccept extends PropsWithChildren {
	switched?: boolean;
	linkStyle: string;
	fakeLinkStyle?: string;
	linkClick?: () => void;
	fakeClick?: () => void;
	url: string;
	state?: { [key: string]: any };
	errorText?: string;
	isFilled?: boolean;
}

const CustomLinkForAccept: React.FC<ICustomLinkForAccept> = ({
	linkStyle,
	switched = true,
	fakeClick,
	linkClick,
	fakeLinkStyle,
	children,
	url,
	state = {},
	errorText = "Недостаточно прав",
	isFilled = false,
}) => {
	return switched ? (
		<Link state={state} onClick={linkClick ? linkClick : () => {}} to={url} className={linkStyle}>
			{isFilled && <div className={styles.notFilled}>Не заполнено</div>}
			{children}
		</Link>
	) : (
		<span
			onClick={() => {
				if (fakeClick) {
					fakeClick();
				} else {
					snackWrapper("error", errorText);
				}
			}}
			className={fakeLinkStyle ? fakeLinkStyle : linkStyle}>
			{children}
		</span>
	);
};

export default React.memo(CustomLinkForAccept);
